import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';
import {
  MultiBuyerStateService,
  defaultAccessConfig,
} from '../services/multi-buyer/multi-buyer-state.service';
import { AccessControlConfig } from '../services/multi-buyer/interfaces/multi-buyer-company.interface';

@Injectable({ providedIn: 'root' })
export class MasterTemplateGuard implements CanActivate {
  constructor(
    private readonly _auth: AuthService,
    private readonly _multiBuyerState: MultiBuyerStateService,
    private readonly _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (this._auth.user?.operatorAcssLvls !== 'none') {
      return of(true);
    }

    const config = this._multiBuyerState.accessControlConfig;
    const config$ =
      config.userRole === undefined ? this._resolveConfig() : of(config);

    return config$.pipe(
      take(1),
      map((resolved) => {
        const enableTemplate = this._auth.buyerConfig?.enableTemplate ?? false;
        const canAccess = resolved.capabilities.canAccessMasterTemplate;

        if (enableTemplate && canAccess) {
          return true;
        }
        return this._router.parseUrl('/access-denied');
      })
    );
  }

  private _resolveConfig(): Observable<AccessControlConfig> {
    const user = this._auth.user!;
    const userRole = this._auth.getMultiBuyerRole(user);

    if (!userRole) {
      return of(defaultAccessConfig());
    }

    return this._multiBuyerState
      .getAccessControlConfig(user.cmp, userRole)
      .pipe(tap((cfg) => this._multiBuyerState.setAccessControlConfig(cfg)));
  }
}
